<template>
	<div class="container mgt-16">
		<div v-for="(catagoryGroup, index) in listData" :key="index">
			<div class="mgt-16" v-if="campaignData && parseInt(campaignData.locationValue) === index + 1">
				<a class="d-block" v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" target="_blank">
					<img :src="campaignData.image" alt="" class="b-radius4"/>
				</a>
				<a class="d-block"  v-else href="javascript:void(0)" style="cursor:none">
					<img :src="campaignData.image" alt="" class="b-radius4"/>
				</a>
			</div>
		<div class="mgt-16" v-if="!!catagoryGroup" :class=" index!==0 ? 'mgt-60' : ''">
			<div class="d-flex justify-content-between align-items-baseline mgt-16 mgb-16" v-if="!!catagoryGroup && catagoryGroup.surveys.length">
				<div class="t-color-headlineBlack t-headline10 font-b t-line-h-33">{{ catagoryGroup.category.name }}</div>
				<div class="t-body2 t-line-h-22 l-spacing98">
					<router-link tabindex="0"
						v-if="catagoryGroup.surveys.length > 1"
						class="t-color-secondaryBtnText font-m"
						:to="`?listType=category&id=${catagoryGroup.category.id}&name=${catagoryGroup.category.name}`"
						>{{ $t("217") }}
					</router-link>
				</div>
			</div>
		</div>
				<div class="mdc-card pdt-8 pdb-8" :class=" index!==0 ? 'mgb-50' : ''" v-if="catagoryGroup.surveys.length">
						<div class="test-carousel-list-type pdt-24 pdb-24 pdl-24 pdr-24 cursor-pointer" 
							v-for="(survey, index2) in catagoryGroup.surveys" :key="index2">
								<div class="d-flex justify-content-between cursor-pointer" @click="viewDetail(survey.id)" @keypress="viewDetail(survey.id)" tabindex="0">
										<div class="flex-grow-1">
												<div class="t-headline7 font-m t-line-h-29 t-line-1">{{ survey.name }}</div>
												<div class="t-body6 font-r t-line-h-22 l-spacing45 mgt-4">{{ $t("218") }}</div>
										</div>
										<div  v-if="survey.earnPoint > 0" class="t-subtitle1 font-b d-flex align-items-center justify-content-center t-nowrap">
												<img src="@/assets/icon_point.svg" class="w-24 d-inline mgr-8" alt="">{{ $n(survey.earnPoint) }}
										</div>
										<div v-else class="t-subtitle1 font-b d-flex align-items-center justify-content-center t-nowrap">
												<img src="@/assets/icon_point.svg" class="w-24 d-inline mgr-8" alt="">0
										</div>
								</div>
						</div>
				</div>
	</div>
	</div>
</template>

<script>
/**
 * 단독 설문 전체 목록  컴포넌트(independent survey total list - list type component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
	props: ["listData", "campaignData"],
	data() {
		return {
			currentDate: Date.now(),
		};
	},
	mounted() {},
	methods: {
		// 상세로 이동(move view)
		viewDetail(id) {
			this.$router.push({
				name: "IndependentSurveyTotalView",
				params: { distId: id },
				query: this.$route.query,
			});
		},
	},
};
</script>
